import _trimEnd from 'lodash/trimEnd';

module.exports = {
  path: ':id',
  indexRoute: {
    onEnter: (nextState, replace) => replace(`${_trimEnd(nextState.location.pathname, '/')}/information`),
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/information'),
        require('./routes/simcard'),
        require('./routes/logs'),
        require('./routes/distributions'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/show/index.js